import Script from 'next/script'
import { useSearchParams } from 'next/navigation'
import { useEffect } from "react"

const cmpUrl = (sourceUrl) => {
    const searchParams = useSearchParams()
    const ip = searchParams.get('_ip')

    if (!ip) return sourceUrl

    const url = new URL(sourceUrl)
    url.searchParams.set("_ip", ip)

    return url.toString()
}

export default function SimpleCMP() {
    useEffect(() => {
        const observer = new MutationObserver(() => {
            const popup = document.querySelector('#simplecmp')
            if (popup) {
                popup.classList.add('simplecmp-wrapper')
            }
        });

        observer.observe(document.body, { childList: true, subtree: true })
        return () => observer.disconnect()
    }, []);

    // old url
    //`${process.env.NEXT_PUBLIC_APP_URL}/api/v1/cmp`
    return (
        <Script src={cmpUrl(process.env.NEXT_PUBLIC_CMP_URL)} strategy="beforeInteractive" />
    )
}